<template>
    <div class="d-flex " :class="expand?'flex-column':'flex-row'">
        <div class="d-flex flex-row" :class="expand?'flex-wrap w-100':'overflow-auto fold-filter flex-grow-1 mr-1'">
            <template v-for="item of options">
                <mini-input :key="item.key"
                            :ref="item.key"
                            class="mr-1 filter-item"
                            :type="inputType(item)"
                            :value.sync="filterForm[item.key]"
                            :options="item.field.options"
                            :options-from-dict="item.field.optionsFromDict"
                            :label="item.label"
                            @change="emit"
                            @enter="emitSearchDelay"></mini-input>
            </template>
        </div>
        <div class="d-flex flex-shrink-0" :class="expand?'mt-1':'m-tb-auto'">
            <div class="ml-auto"></div>
            <b-button variant="outline-secondary" class="mr-1" @click="expand=!expand">
                <i class="fa-solid" :class="!expand?'fa-angles-down':'fa-angles-up'"></i>
            </b-button>
            <b-button variant="outline-secondary" class="mr-1" @click="handleReset">
                <i class="fa fa-fw fa-lg fa-eraser"></i>
                <span class="text">{{ $t("btn.basic.clear") }}</span>
            </b-button>
            <mini-button :loading="searchLoading" variant="primary" class="search-btn"
                         @btnClick="emitSearch">
                <i class="fa fa-fw fa-lg fa-search"></i>
                <span class="text">{{ $t("btn.basic.search") }}</span>
            </mini-button>
        </div>
    </div>
</template>

<script>

import MiniInput from "@/components/common/inputs/MiniInput.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";

const OP = [
    {name: 'In', label: '包含/In', onlyType: 'select'},
    {name: 'ILike', label: '包含/Like', onlyOrigin: 'String'},
    {name: 'Between', label: '介于之间', onlyOrigin: 'Date'},
    {name: 'Eq', label: '等于', notOrigin: 'Date', notType: 'select'},
];
export default {
    name: "TableFilter",
    components: {MiniButton, MiniInput},
    mixins: [emCommonUtilMixin],
    props: {
        fields: Array,
        searchLoading: Boolean,
        defaultForm: Object,
    },
    data() {
        return {
            notAccept: new Set(['image', 'attachment']),
            filters: {},
            filterForm: this.defaultForm ? {...this.defaultForm} : {},
            expand: false,
        }
    },
    computed: {
        options() {
            let tempList = [];
            if (this.fields) {
                for (let item of this.fields) {
                    if (item.visible || this.showInvisible) {
                        let type = item.type;
                        if (this.notAccept.has(type)) {
                            continue;
                        }
                        let transLabel = this.$t(item.label);
                        for (let op of OP) {
                            if (op.onlyOrigin && op.onlyOrigin !== item.originalType
                                || op.onlyType && op.onlyType !== type
                                || op.notOrigin && op.notOrigin === item.originalType
                                || op.notType && op.notType === type) {
                                continue;
                            }
                            tempList.push({
                                label: transLabel,
                                key: item.key + op.name,
                                op: op.name,
                                field: item,
                            })
                            break;
                        }
                    }
                }
            }
            return tempList;
        },
    },
    methods: {
        inputType(item) {
            if (item.op === 'In') {
                return 'select-multi';
            } else if (item.op === 'Between') {
                return 'date-range';
            } else {
                return item.field.type;
            }
        },
        emit() {
            this.$emit('change', this.filterForm);
        },
        emitSearch() {
            this.cardOpen = false;
            this.$emit("search", this.filterForm);
        },
        emitSearchDelay() {
            this.$nextTick(() => this.emitSearch());
        },
        handleReset() {
            this.filterForm = {};
            this.emit();
        },
    }
}
</script>

<style scoped lang="scss">
.filter-item {
    width: 200px !important;
    min-width: 200px;
}

.search-btn {
    width: 90px;
}

.fold-filter {
    /* 右侧滚动阴影：仅当右侧仍有未显示内容时显露，滚动到末尾自动消失。
       两层背景叠加（容器背景为白色 #fff）：
       1) 白色遮罩，随内容滚动(local)，滚到末尾时盖住阴影；
       2) 径向阴影，固定在容器右缘(scroll)，有溢出时透出。*/
    background:
        linear-gradient(to left, #fff, rgba(255, 255, 255, 0)) 100% 0 / 28px 100% no-repeat local,
        radial-gradient(farthest-side at 100% 50%, rgba(20, 46, 74, .16), rgba(20, 46, 74, 0)) 100% 0 / 14px 100% no-repeat scroll;

    /* 横向滚动条：默认隐藏，悬停于筛选区时才显现 */
    &::-webkit-scrollbar {
        height: 3px;
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: transparent;
        border-radius: 6px;
        transition: background-color .2s ease;
    }

    &:hover::-webkit-scrollbar-thumb {
        background-color: #c0c0c0;
    }

    &:hover::-webkit-scrollbar-thumb:hover {
        background-color: #7c7c7c;
    }

    &::-webkit-scrollbar-corner {
        background-color: transparent;
    }
}
</style>
